import React from 'react';
import { nearbyAttractions, hillStations } from '../../mock';

function Row({ items }) {
  const doubled = [...items, ...items];
  return (
    <div className="group overflow-hidden">
      <div className="flex gap-5 animate-[marquee_40s_linear_infinite] group-hover:[animation-play-state:paused]">
        {doubled.map((it, i) => (
          <div key={i} className="shrink-0 w-64">
            <div className="relative aspect-[4/5] overflow-hidden">
              <img src={it.image} alt={it.name} className="h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f1a14] via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="text-white font-serif text-lg">{it.name}</div>
                {it.distance && <div className="text-[#c9a56a] text-xs mt-1">{it.distance}</div>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Nearby() {
  return (
    <section className="bg-[#0f1a14] text-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-4">
          <div className="h-px w-12 bg-[#c9a56a]" />
          <span className="text-[#c9a56a] text-xs uppercase tracking-[0.3em]">Around You</span>
        </div>
        <h2 className="font-serif text-4xl md:text-6xl leading-[1.05] max-w-3xl">Nearby attractions from the township.</h2>
      </div>
      <div className="mt-14">
        <Row items={nearbyAttractions} />
      </div>

      <div className="mx-auto max-w-7xl px-6 lg:px-10 mt-24">
        <div className="flex items-center gap-3 mb-4">
          <div className="h-px w-12 bg-[#c9a56a]" />
          <span className="text-[#c9a56a] text-xs uppercase tracking-[0.3em]">Explore</span>
        </div>
        <h2 className="font-serif text-4xl md:text-6xl leading-[1.05] max-w-3xl">Hill stations, all within a scenic drive.</h2>
      </div>
      <div className="mt-14">
        <Row items={hillStations} />
      </div>
    </section>
  );
}
